export const hasPermission = (user, permission) =>
  Array.isArray(user?.permissions) && user.permissions.includes(permission);

export const hasAnyPermission = (user, permissions) =>
  permissions.some((permission) => hasPermission(user, permission));

export const isRootUser = (user) => user?.role === "ROOT";

export const USER_ROLES = ["ROOT", "ADMIN", "SUPERVISOR", "EDITOR", "READER"];

export const PERMISSION_LABELS = {
  STARTERS_READ: "View starters",
  STARTERS_CREATE: "Create starters",
  STARTERS_UPDATE: "Edit starters",
  STARTERS_DELETE: "Delete starters",
  STARTERS_VISIBILITY_MANAGE: "Manage starter visibility",
  ARMATURES_READ: "View armatures",
  ARMATURES_CREATE: "Create armatures",
  ARMATURES_UPDATE: "Edit armatures",
  ARMATURES_DELETE: "Delete armatures",
  ARMATURES_VISIBILITY_MANAGE: "Manage armature visibility",
  FIELD_CASES_READ: "View field cases",
  FIELD_CASES_CREATE: "Create field cases",
  FIELD_CASES_UPDATE: "Edit field cases",
  FIELD_CASES_DELETE: "Delete field cases",
  FIELD_CASES_VISIBILITY_MANAGE: "Manage field case visibility",
  USERS_READ: "View accounts",
  USERS_CREATE: "Create accounts",
  USERS_UPDATE: "Edit accounts",
  USERS_MANAGE_ROLES: "Assign roles to accounts",
  USERS_MANAGE_ADMINS: "Manage admin accounts",
  USERS_ENFORCE_2FA: "Require two-factor authentication",
  ACCOUNTS_MANAGE_STATUS: "Change account status",
  API_DOCS_READ: "View API documentation",
  SESSIONS_MANAGE: "Manage sessions",
};
